import api from '../..'

const downloadExternalCourse = (id: number) => {
  return api.post(`administration/external_courses/report`, {
    id
  })
}

export default downloadExternalCourse